import { ActivityTypeEnum } from '@sport-activities/sdk';

import { ToggleDefaultValueActivityTypeInterface } from './interfaces/type.config.interface';

export const ActivityCreationTypes: ToggleDefaultValueActivityTypeInterface = {
  activity_creation_group_lesson_type: {
    labelKey: 'activity_creation.type.form.type.collective_class.label',
    htmlValue: 'GROUP_LESSON' as ActivityTypeEnum,
  },
  activity_creation_multi_day_course_type: {
    labelKey: 'activity_creation.type.form.type.course.label',
    htmlValue: 'MULTI_DAY_COURSE' as ActivityTypeEnum,
  },
  activity_creation_event_type: {
    labelKey: 'activity_creation.type.form.type.event.label',
    htmlValue: 'EVENT' as ActivityTypeEnum,
  },
  activity_creation_workshop_type: {
    labelKey: 'activity_creation.type.form.type.workshop.label',
    htmlValue: 'WORKSHOP' as ActivityTypeEnum,
  },
  activity_creation_live_type: {
    labelKey: 'activity_creation.type.form.type.live.label',
    htmlValue: 'LIVE' as ActivityTypeEnum,
  },
  activity_creation_birthday_type: {
    labelKey: 'activity_creation.type.form.type.birthday.label',
    htmlValue: 'BIRTHDAY' as ActivityTypeEnum,
  },
  activity_creation_playground_rent_type: {
    labelKey: 'activity_creation.type.form.type.playground_type.label',
    htmlValue: 'PLAYGROUND_RENT' as ActivityTypeEnum,
  },
  activity_creation_test_type: {
    labelKey: 'activity_creation.type.form.type.product_test.label',
    htmlValue: 'PRODUCT_TEST' as ActivityTypeEnum,
  },
};
